import React from 'react';
import clsx from 'clsx';
import {Skeleton, type SkeletonProps} from '@mui/material';
import {
	composeClasses,
	styled,
	type WithClasses,
	type WithMuiPropOverrides,
} from '@netx/core-components/Theme';
import {
	chipSkeletonClasses,
	getChipSkeletonUtilityClass,
	CHIP_SKELETON_CLASS_NAME,
	type ChipSkeletonClasses,
} from './chipSkeletonClasses';

type AutoTaskEditorOwnerState = WithClasses<ChipSkeletonClasses, {}>;

const useUtilityClasses = (ownerState: AutoTaskEditorOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getChipSkeletonUtilityClass, classes);
};

const ChipSkeletonRoot = styled(Skeleton, {
	name: CHIP_SKELETON_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	borderRadius: 16,
	flex: '0 0 auto',
	display: 'inline-flex',
	margin: 3,
	width: 70,
}));

export interface ChipSkeletonProps
	extends Omit<WithMuiPropOverrides<SkeletonProps>, 'classes'>,
		WithClasses<ChipSkeletonClasses, {}> {
	count?: number;
}

export const ChipSkeletonPrimitive = ({
	classes: _classes,
	className,
	count,
	...props
}: ChipSkeletonProps) => {
	const ownerState: AutoTaskEditorOwnerState = {classes: _classes};
	const classes = useUtilityClasses(ownerState);

	return (
		<>
			{Array(count || 1)
				.fill(null)
				.map((val, index) => (
					<ChipSkeletonRoot
						key={index}
						className={clsx(classes.root, className)}
						height={32}
						ownerState={ownerState}
						variant="rectangular"
						{...props}
					/>
				))}
		</>
	);
};

export const ChipSkeleton = ChipSkeletonPrimitive;

export default ChipSkeleton;
